import { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/DeleteOutlined'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Drawer from '@mui/material/Drawer'

import FilterAttributes from './filter-attributes'
import { actions, types } from '../../module'

const Filters = ({
  model,
  filters,
  filtered,
  visible,
  onClear,
  onFilter,
  onHide,
}) => {
  const isEmptyList = (list) => Array.isArray(list) && list.length === 0

  const noFilters = isEmptyList(
    Object.entries(filters).filter(([_, value]) => !isEmptyList(value))
  )

  // Handle exception query param for dashboard click-through
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const exception = params.get('exception')
    if (exception) {
      onFilter({ exception })
    }
  }, [onFilter])

  return (
    <Drawer
      anchor="right"
      open={visible}
      onClose={onHide}
      variant="temporary"
      PaperProps={{
        style: { width: 420, maxWidth: '100%' },
      }}>
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        {/* Close button */}
        <Box
          sx={{
            padding: 2,
            display: 'flex',
            justifyContent: 'flex-end',
          }}>
          <IconButton onClick={onHide} size="small">
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19.8099 9.02479L15 13.8306L10.1901 9.02479L9.02479 10.1901L13.8306 15L9.02479 19.8099L10.1901 20.9752L15 16.1694L19.8099 20.9752L20.9752 19.8099L16.1694 15L20.9752 10.1901L19.8099 9.02479Z"
                fill="#EB0A1E"/>
            </svg>
          </IconButton>
        </Box>

        {/* Filters */}
        <Box sx={{ paddingX: 3, flexGrow: 1 }}>
          {noFilters ? (
            'No Filters Available'
          ) : (
            <FilterAttributes
              filters={filters}
              filtered={filtered}
              onFilter={onFilter}/>
          )}
        </Box>

        {/* Clear */}
        <Box sx={{ padding: 3 }}>
          <Button
            fullWidth
            variant="contained"
            onClick={onClear}
            startIcon={<DeleteIcon />}>
            Clear
          </Button>
        </Box>
      </Box>
    </Drawer>
  )
}

Filters.propTypes = {
  model: types.ModuleType.isRequired,
  visible: PropTypes.bool,
  filters: types.FiltersType.isRequired,
  filtered: types.FilteredType.isRequired,
  onClear: PropTypes.func.isRequired,
  onFilter: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
}

const mapStateToProps = ({ reportExceptions }) => ({
  model: reportExceptions,
  visible: reportExceptions.showFilters,
  filters: reportExceptions.filters,
  filtered: reportExceptions.filtered,
})

const mapDispatchToProps = {
  onClear: actions.clearFilters,
  onFilter: actions.updateFilters,
  onHide: actions.hideFilters,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Filters)
